<template>
  <div class="medical-report-list">
    <div :style="bluebg" class="medical-report-list-bg">
      <div style="width:100%">体检报告列表</div>
      <!-- <div class="medical-report-list-info">
        <div class="medical-report-list-info-detail">
          <div>姓名：<span>王老五</span></div>
          <div>性别：<span>男</span></div>
        </div>
        <div class="medical-report-list-info-number">
          <div>体检号</div>
          <div style="color:#333">23131231</div>
        </div>
      </div> -->
      <div class="medical-report-list-content">
        <div class="medical-report-list-content-tab">
          <div
            :class="
              tabindex === '0'
                ? 'medical-report-list-content-tab-select'
                : 'medical-report-list-content-tab-unselect'
            "
            @click="tabClick('0')"
            style="border-radius:0.63rem 0 0 0;"
          >
            报告详情
          </div>
          <div
            :class="
              tabindex === '1'
                ? 'medical-report-list-content-tab-select'
                : 'medical-report-list-content-tab-unselect'
            "
            @click="tabClick('1')"
            style="border-radius:0 0.63rem  0 0;"
          >
            体检总结
          </div>
        </div>
        <div v-if="tabindex === '0'" class="medical-report-list-content-list">
          <van-grid :border="false" :column-num="2" :gutter="15">
            <van-grid-item
              slot="default"
              v-for="(item, index) in list"
              :key="index"
            >
              <div
                slot="default"
                @click="itemClick(item)"
                class="medical-report-list-content-list-item"
              >
                <div class="medical-report-list-content-list-item-title">
                  <span v-if="item.reportType === '2'">非</span>检验报告
                </div>
                <div class="medical-report-list-content-list-item-name">
                  {{ item.checkItemName }}
                </div>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
        <div v-if="tabindex === '1'" class="medical-report-list-content-detail">
          <div class="medical-report-list-content-detail-title">体检结论</div>
          <div class="medical-report-list-content-detail-content">
            {{ examineresult }}
          </div>
          <div class="medical-report-list-content-detail-title">健康指南</div>
          <div class="medical-report-list-content-detail-content">
            {{ checkItemName1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bluebg: {
        backgroundImage: `url(${require("@assets/vaccine_form_bluebg.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto"
      },
      list: [],
      startDate: "",
      endDate: "",
      showStart: false,
      showEnd: false,
      openId: "",
      tabindex: "0",
      reportNo: "",
      examineresult: "",
      checkItemName1: ""
    };
  },
  created() {
    this.reportNo = this.$route.query.reportNo;
    this.getList();
    this.getConclusion();
  },
  methods: {
    getList() {
      this.$http
        .post(this.$api.MES_REPORT_LIST, { reportNo: this.reportNo })
        .then(res => {
          this.list = res;
        })
        .catch(() => {
          this.list = [];
        });
    },
    getConclusion() {
      this.$http
        .post(this.$api.MES_REPORT_DETAIL, {
          reportNo: this.reportNo,
          reportType: "3"
        })
        .then(res => {
          this.examineresult = res[0].examineresult;
          this.checkItemName1 = res[0].checkItemName1;
        })
        .catch(() => {
          this.list = [];
        });
    },
    itemClick(item) {
      this.$router.push({
        name: "medical-report-detail",
        query: {
          ...item
        }
      });
    },
    tabClick(value) {
      this.tabindex = value;
    },
    // 确认选择的时间
    confirmPicker(selStartDate, SelendDate) {
      this.startDate = selStartDate;
      this.endDate = SelendDate;
      this.getList();
    }
    // cancelClick(item) {
    //   this.$http
    //     .post(this.$api.VAC_CANCEL, {
    //       appointId: item.appointId,
    //       openId: this.openId,
    //       idCard: item.idCard
    //     })
    //     .then(res => {
    //       this.$dialog
    //         .alert({
    //           title: "",
    //           message: "取消成功"
    //         })
    //         .then(() => {
    //           this.getList();
    //         });
    //     })
    //     .catch(error => {
    //       alert(error.message);
    //     });
    // }
  }
};
</script>
<style lang="less">
.medical-report-list {
  background-color: #f7f8fa;
  &-bg {
    width: 100%;
    height: 17.5rem;
    padding-top: 1.66rem;
    color: white;
    font-weight: 500;
    font-size: 1.31rem;
    text-align: center;
  }
  &-content {
    margin: 1rem 5% 0.94rem 5%;
    &-tab {
      display: flex;
      overflow: hidden;
      font-weight: 500;
      font-size: 1.19rem;
      line-height: 3.14rem;
      text-align: center;
      border-radius: 0.63rem 0.63rem 0 0;
      &-select {
        width: 50%;
        color: white;
        background-color: #4396f7;
      }
      &-unselect {
        width: 50%;
        color: #666;
        background-color: white;
      }
    }
    &-detail {
      padding: 15px 1.13rem;
      background-color: white;
      border: 1px solid #e8e8e8;
      &-title {
        margin: 0 3rem;
        color: #4396f7;
        font-weight: 600;
        font-size: 0.84rem;
        line-height: 2rem;
        text-align: center;
        background-color: #ecf9ff;
        border-radius: 0.63rem;
      }
      &-content {
        padding: 1.47rem 0;
        color: #666;
        font-size: 0.74rem;
      }
    }
    &-list {
      padding: 15px 0;
      background-color: white;
      border: 1px solid #e8e8e8;
      &-item {
        width: 100%;
        height: 7.38rem;
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-all;
        border: 1px solid #e8e8e8;
        border-radius: 10px;
        &-title {
          color: #4396f7;
          font-weight: 600;
          font-size: 0.74rem;
          line-height: 2rem;
          text-align: center;
          background-color: #ecf9ff;
        }
        &-name {
          margin-top: 1.53rem;
          color: #4396f7;
          font-weight: 600;
          font-size: 0.93rem;
          text-align: center;
          background-color: white;
        }
      }
    }
  }
  &-info {
    margin: 1.78rem 5% 0 5%;
    padding: 0 1.25rem;
    color: #666;
    font-size: 0.94rem;
    line-height: 2.81rem;
    background-color: white;
    border-radius: 0.63rem;
    &-detail {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f9f9f9;
      span {
        color: #333;
      }
    }
    &-number {
      display: flex;
      justify-content: space-between;
    }
  }
  .van-grid-item__content {
    padding: 0;
  }
}
</style>
